<template lang="pug">
  section.organisation-list
    v-card-title
      h3 Организации
    v-card-text
      v-layout(row justify-center)
        v-btn(large color="success" @click="showDialog").mb-4
          v-icon.mr-2 add
          span Создать
      v-layout(row justify-center).pb-4
        v-flex(xs11)
          v-data-table(
            :headers="headers",
            :items="organisationList",
            :loading="loading",
            no-data-text="Нет данных для отображения",
            hide-actions)
            template(slot="items" slot-scope="props")
              td {{ props.index + 1 }}
              td {{ props.item.name }}
              td
                a(@click="showDivisionsList(props.item.id, props.item)") Просмотреть
              td
                a(@click="editOrganisation(props.item.id, props.item)") Редактировать
              td
                a(@click="submitDeleteOrganisation(props.item.id, props.item.name)", class="red--text") Удалить
    AddOrganisation(
      :show="addDialog",
      @close-dialog="closeDialog",
      @update-organisation-list="getOrganisationList")
    DeleteDialog(
      :show="deleteDialog",
      dispatchType="organisation",
      @close-dialog="closeDeleteOrganisationDialog",
      @delete-organisation="deleteOrganisation")
      div(slot="title") Вы действительно хотите удалить,<br><b>{{ organisationName }}</b>?
    Snackbar(
      :show="isSnackbar",
      @close-snackbar="closeSnackbar")
      div(slot="message") {{ errorMessage }}
</template>

<script>
import axios from 'axios'
import DeleteDialog from '../../../Common/DeleteDialog/DeleteDialog'
import AddOrganisation from '../AddOrganisation/AddOrganisation'
import Snackbar from '../../../Common/Snackbar/Snackbar'
export default {
  name: 'OrganisationList',
  components: {
    Snackbar,
    AddOrganisation,
    DeleteDialog },
  data: () => ({
    organisationList: [],
    headers: [
      { text: '№', value: 'id', sortable: false },
      { text: 'Название', value: 'name' },
      { text: 'Действие', value: 'action1', sortable: false, align: 'left' },
      { text: 'Действие', value: 'action2', sortable: false, align: 'left' },
      { text: 'Действие', value: 'action3', sortable: false, align: 'left' }
    ],
    loading: false,
    addDialog: false,
    deleteDialog: false,
    organisationId: '',
    organisationName: '',
    isSnackbar: false,
    errorMessage: ''
  }),
  mounted() {
    this.getOrganisationList()
  },
  methods: {
    closeSnackbar() {
      this.isSnackbar = false
      this.errorMessage = ''
    },
    getOrganisationList() {
      this.loading = true
      axios({
        method: 'GET',
        url: '/api/Organisation/list'
      }).then(response => {
        this.organisationList = response.data.result
        this.loading = false
      }).catch(error => {
        console.log(error.response.data.message)
        this.loading = false
      })
    },
    showDialog() {
      this.addDialog = true
    },
    closeDialog() {
      this.addDialog = false
    },
    submitDeleteOrganisation(id, name) {
      this.organisationId = id
      this.organisationName = name
      this.deleteDialog = true
    },
    closeDeleteOrganisationDialog() {
      this.deleteDialog = false
      this.organisationId = ''
      this.organisationName = ''
    },
    deleteOrganisation() {
      axios({
        method: 'DELETE',
        url: `/api/Organisation/delete/${this.organisationId}`
      }).then(response => {
        // console.log(response.data)
        if (response.data.success) {
          this.deleteDialog = false
          this.getOrganisationList()
        }
      }).catch(error => {
        this.errorMessage = error.response.data.message
        this.isSnackbar = true
      })
    },
    showDivisionsList(id, data) {
      this.$router.push({ path: `/main/organisation/${id}` })
      this.$store.commit('SAVE_ORGANISATION_ITEM', data)
    },
    editOrganisation(id, data) {
      this.$router.push({ path: `/main/organisation/edit/${id}` })
      this.$store.commit('SAVE_ORGANISATION_ITEM', data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-btn {
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Organisation/OrganisationList/OrganisationList.vue